import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import NumberInput from '@/components/NumberInput';

import { filterValueStyle } from '../styles';
import { FilterValueProps } from '../types';

function NumberFilter(props: FilterValueProps) {
  const { t } = useTranslation();
  const { filterValue, onFilterValueChange, disabled, error } = props;
  const [inputVal, setInputVal] = useState(filterValue);
  useEffect(() => {
    setInputVal(filterValue);
  }, [filterValue]);

  const hasError = useMemo(
    () => error && !disabled && !filterValue,
    [disabled, error, filterValue],
  );

  return (
    <Stack
      className={cn(filterValueStyle, {
        'cursor-not-allowed': disabled,
      })}
      direction="col">
      <NumberInput
        canBeEmpty
        className={cn('number-input w-full', { 'pointer-events-none': disabled })}
        error={hasError}
        min={0}
        placeholder={t('Group:Editor.Value')}
        size="medium"
        value={Number(inputVal)}
        onBlur={(val: number) => onFilterValueChange(val.toString())}
        onChange={(val: number) => setInputVal(val.toString())}
      />
      {hasError ? (
        <Typography className="mt-8" color="text-text-error" variant="body-short-03">
          {t('Common:Form.Error.ValueCantBeEmpty')}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default NumberFilter;
